module.exports = __webpack_public_path__ + "media/images/sales/early/text-mv-duedate-year-2023-00817b3546efb796e6aa00b41ce69456.svg";